// Cache a settled rewards assignment for this tab through authentication refreshes.
const REWARDS_UNLOCKED_KEY = 'morfi_rewards_unlocked';

export function markRewardsUnlocked(): void {
  try {
    window.sessionStorage.setItem(REWARDS_UNLOCKED_KEY, '1');
  } catch {
    // SILENT-CATCH: sessionStorage blocked (private mode) — the rewards gate
    // falls back to reading the live flag, so this is a best-effort fast path.
  }
}

export function readRewardsUnlocked(): boolean {
  try {
    return window.sessionStorage.getItem(REWARDS_UNLOCKED_KEY) === '1';
  } catch {
    // SILENT-CATCH: sessionStorage throws in private mode / when disabled —
    // treat as "not recorded" and let the gate read the live flag.
    return false;
  }
}
